import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapCollection } from '../../ruutsApi/normalize'

export default async function getMonitoringOnly({ farmId, signal }) {
  const response = await apiClient.get(endpoints.sites, {
    params: { farmId, isValidationSite: false, isDeleted: false },
    signal,
  })
  return unwrapCollection(response)
}
